import { RouteObject, createBrowserRouter, Navigate, useLocation } from 'react-router-dom';
import App from 'App';
import MainLayout from 'layouts/MainLayout';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import SimpleSignIn from 'pages/authentication/SignIn';
import Home from 'pages/dashboard/Home';
import ButtonExample from 'pages/template/modules/components/ButtonExample';
import AccordionExample from 'pages/template/modules/components/AccordionExample';
import AvatarExample from 'pages/template/modules/components/AvatarExample';
import BadgeExample from 'pages/template/modules/components/BadgeExample';
import BreadcrumbExample from 'pages/template/modules/components/BreadcrumbExample';
import CardExample from 'pages/template/modules/components/CardExample';
import BootstrapCarousel from 'pages/template/modules/components/BootstrapCarousel';
import CollapseExample from 'pages/template/modules/components/CollapseExample';
import DropdownExample from 'pages/template/modules/components/DropdownExample';
import ListGroupExample from 'pages/template/modules/components/ListGroupExample';
import ModalExample from 'pages/template/modules/components/ModalExample';
import OffcanvasExample from 'pages/template/modules/components/OffcanvasExample';
import ProgressbarExample from 'pages/template/modules/components/ProgressbarExample';
import PlaceholderExample from 'pages/template/modules/components/PlaceholderExample';
import PaginationExample from 'pages/template/modules/components/PaginationExample';
import PopoversExample from 'pages/template/modules/components/PopoversExample';
import SpinnerExample from 'pages/template/modules/components/SpinnerExample';
import ToastsExample from 'pages/template/modules/components/ToastsExample';
import TooltipExample from 'pages/template/modules/components/TooltipExample';
import AlertsExample from 'pages/template/modules/components/AlertsExample';
import FormControlExample from 'pages/template/modules/forms/basic/FormControlExample';
import InputGroupExample from 'pages/template/modules/forms/basic/InputGroupExample';
import SelectExample from 'pages/template/modules/components/SelectExample';
import ChecksExample from 'pages/template/modules/components/ChecksExample';
import RangeExample from 'pages/template/modules/components/RangeExample';
import FloatingLabelExample from 'pages/template/modules/components/FloatingLabelExample';
import FormLayoutExample from 'pages/template/modules/components/FormLayoutExample';
import FormValidationExample from 'pages/template/modules/components/FormValidationExample';
import BackgroundExample from 'pages/template/modules/utilities/BackgroundExample';
import BorderExample from 'pages/template/modules/utilities/BorderExample';
import ColorsExample from 'pages/template/modules/utilities/ColorsExample';
import DisplayExample from 'pages/template/modules/utilities/DisplayExample';
import FlexExample from 'pages/template/modules/utilities/FlexExample';
import StackExample from 'pages/template/modules/utilities/StackExample';
import FloatExample from 'pages/template/modules/utilities/FloatExample';
import InteractionsExample from 'pages/template/modules/utilities/InteractionsExample';
import OpacityExample from 'pages/template/modules/utilities/OpacityExample';
import OverflowExample from 'pages/template/modules/utilities/OverflowExample';
import PositionExample from 'pages/template/modules/utilities/PositionExample';
import ShadowsExample from 'pages/template/modules/utilities/ShadowsExample';
import SizingExample from 'pages/template/modules/utilities/SizingExample';
import SpacingExample from 'pages/template/modules/utilities/SpacingExample';
import VerticalAlignExample from 'pages/template/modules/utilities/VerticalAlignExample';
import VisibilityExample from 'pages/template/modules/utilities/VisibilityExample';
import BasicTableExample from 'pages/template/modules/tables/BasicTableExample';
import GridExample from 'pages/template/modules/utilities/GridExample';
import TypographyExample from 'pages/template/modules/utilities/TypographyExample';
import Configuration from 'pages/template/documentation/customization/Configuration';
import Styling from 'pages/template/documentation/customization/Styling';
import DarkMode from 'pages/template/documentation/customization/DarkMode';
import GettingStarted from 'pages/template/documentation/GettingStarted';
import DesignFile from 'pages/template/documentation/DesignFile';
import ChangeLog from 'pages/template/documentation/ChangeLog';
import NavsExample from 'pages/template/modules/components/NavsExample';
import TabsExample from 'pages/template/modules/components/TabsExample';
import NavbarExample from 'pages/template/modules/components/NavbarExample';
//import Ecommerce from 'pages/dashboard/ecommerce';
import EcommerceLayout from 'layouts/EcommerceLayout';
import Homepage from 'pages/template/apps/e-commerce/customer/Homepage';
import ProductDetails from 'pages/template/apps/e-commerce/customer/ProductDetails';
import Cart from 'pages/template/apps/e-commerce/customer/Cart';
import Checkout from 'pages/template/apps/e-commerce/customer/checkout/Checkout';
import ProductsFilter from 'pages/template/apps/e-commerce/customer/ProductsFilter';
import ShippingInfo from 'pages/template/apps/e-commerce/customer/checkout/ShippingInfo';
import Profile from 'pages/template/apps/e-commerce/customer/Profile';
import Wishlist from 'pages/template/apps/e-commerce/customer/Wishlist';
import FavoriteStores from 'pages/template/apps/e-commerce/customer/FavoriteStores';
import Invoice from 'pages/template/apps/e-commerce/customer/Invoice';
import OrderTracking from 'pages/template/apps/e-commerce/customer/OrderTracking';
import AddProduct from 'pages/template/apps/e-commerce/admin/AddProduct';
import Products from 'pages/template/apps/e-commerce/admin/Products';
import Customers from 'pages/template/apps/e-commerce/admin/Customers';
import Orders from 'pages/template/apps/e-commerce/admin/Orders';
import OrderDetails from 'pages/template/apps/e-commerce/admin/OrderDetails';
import Refund from 'pages/template/apps/e-commerce/admin/Refund';
import CustomerDetails from 'pages/template/apps/e-commerce/admin/CustomerDetails';
//import ProjectManagement from 'pages/dashboard/ProjectManagement';
import CreateNew from 'pages/template/apps/project-management/CreateNew';
import ProjectListView from 'pages/template/apps/project-management/ProjectListView';
import ProjectDetails from 'pages/template/apps/project-management/ProjectDetails';

import ProjectTodoList from 'pages/template/apps/project-management/ProjectTodoList';
import ProjectBoardView from 'pages/template/apps/project-management/ProjectBoardView';
import ProjectCardView from 'pages/template/apps/project-management/ProjectCardView';
import Default from 'pages/template/landing/Default';
import CreateAnEvent from 'pages/template/apps/events/CreateAnEvent';
import EventDetail from 'pages/template/apps/events/EventDetail';
import Chat from 'pages/template/apps/chat/Chat';
import ChatHomepage from 'pages/template/apps/chat/ChatHomepage';
import ChatConversation from 'pages/template/apps/chat/ChatConversation';
import FaqAccordion from 'pages/faq/FaqAccordion';
import Inbox from 'pages/template/apps/email/Inbox';
import EmailDetail from 'pages/template/apps/email/EmailDetail';
import Compose from 'pages/template/apps/email/Compose';
import Notifications from 'pages/notifications/Notifications';
import SocialProfile from 'pages/template/apps/social/SocialProfile';
import Settings from 'pages/settings/Settings';
import Feed from 'pages/template/apps/social/Feed';
import Error404 from 'pages/error/Error404';
import Error403 from 'pages/error/Error403';
import Error500 from 'pages/error/Error500';
import AdvanceTableExample from 'pages/template/modules/tables/AdvanceTableExample';

/*
import SimpleSignUp from 'pages/authentication/simple/SignUp';
import SimpleSignOut from 'pages/authentication/simple/SignOut';
import SimpleResetPassword from 'pages/authentication/simple/ResetPassword';
import SimpleLockScreen from 'pages/authentication/simple/LockScreen';
import SimpleTwoFA from 'pages/authentication/simple/TwoFA';
import SimpleForgotPassword from 'pages/authentication/simple/ForgotPassword';
*/
import Showcase from 'pages/template/Showcase';
import VerticalSidenav from 'layouts/VerticalSidenav';
import DarkModeDemo from 'layouts/DarkModeDemo';
import SidenavCollapse from 'layouts/SidenavCollapse';
import Darknav from 'layouts/Darknav';
import TopnavSlim from 'layouts/TopnavSlim';
import NavbarTopSlim from 'layouts/NavbarTopSlim';
import NavbarTop from 'layouts/NavbarTop';
import NavbarHorizontalSlim from 'layouts/NavbarHorizontalSlim';
import ComboNav from 'layouts/ComboNav';
import ComboNavSlim from 'layouts/ComboNavSlim';
import LightboxExample from 'pages/template/modules/components/LightboxExample';
import EmojiButtonExample from 'pages/template/modules/forms/advance/EmojiButtonExample';
import RatingExample from 'pages/template/modules/forms/advance/RatingExample';
import CountupExample from 'pages/template/modules/components/CountupExample';
import EditorExample from 'pages/template/modules/forms/advance/EditorExample';
import SwiperCarousel from 'pages/template/modules/components/SwiperCarousel';
import FileUploaderExample from 'pages/template/modules/forms/advance/FileUploaderExample';
import AdvanceSelectExample from 'pages/template/modules/forms/advance/AdvanceSelectExample';
import DatePickerExample from 'pages/template/modules/forms/advance/DatePickerExample';
import ECharts from 'pages/template/modules/charts/ECharts';
import GanttChart from 'pages/template/modules/charts/GanttChart';
import Members from 'pages/template/Members';
import DualNav from 'layouts/DualNav';

//import Crm from 'pages/dashboard/Crm';
import LeadDetails from 'pages/template/apps/crm/LeadDetails';
import Analytics from 'pages/template/apps/crm/Analytics';
import DealDetails from 'pages/template/apps/crm/DealDetails';
import ReportDetails from 'pages/template/apps/crm/ReportDetails';
import CardSignIn from 'pages/template/authentication/card/SignIn';
import CardSignUp from 'pages/template/authentication/card/SignUp';
import CardForgotPassword from 'pages/template/authentication/card/ForgotPassword';
import CardSignOut from 'pages/template/authentication/card/SignOut';
import CardResetPassword from 'pages/template/authentication/card/ResetPassword';
import CardTwoFA from 'pages/template/authentication/card/TwoFA';
import CardLockScreen from 'pages/template/authentication/card/LockScreen';
import Leads from 'pages/template/apps/crm/Leads';
import Reports from 'pages/template/apps/crm/Reports';
import AddContact from 'pages/template/apps/crm/AddContact';
import SplitSignIn from 'pages/template/authentication/split/SignIn';
import SplitSignUp from 'pages/template/authentication/split/SignUp';
import SplitSignOut from 'pages/template/authentication/split/SignOut';
import SplitForgotPassword from 'pages/template/authentication/split/ForgotPassword';
import SplitResetPassword from 'pages/template/authentication/split/ResetPassword';
import SplitLockScreen from 'pages/template/authentication/split/LockScreen';
import SplitTwoFA from 'pages/template/authentication/split/TwoFA';
import { Suspense, lazy } from 'react';
import PhoenixLoader from 'components/common/PhoenixLoader';
import Migrations from 'pages/template/documentation/Migrations';
import Kanban from 'pages/template/apps/kanban/Kanban';
import Boards from 'pages/template/apps/kanban/Boards';
import CreateBoard from 'pages/template/apps/kanban/CreateBoard';
import WizardExample from 'pages/template/modules/forms/WizardExample';
import Deals from 'pages/template/apps/crm/Deals';
import FaqTab from 'pages/faq/FaqTab';
import Alternate from 'pages/template/landing/Alternate';
import Calendar from 'pages/template/apps/calendar/Calendar';
import CalendarExample from 'pages/template/modules/components/CalendarExample';
import DraggableExample from 'pages/template/modules/components/DraggableExample';
import Widgets from 'pages/template/modules/Widgets';
import ComingSoon from 'pages/template/ComingSoon';

/* Authtentication side */
import { useAuth } from 'providers/AuthProvider'
import ConversationDetails from 'pages/meetings/ConversationDetails';
import Contacts from 'pages/contacts/Contacts';
import AddContactTH from 'pages/contacts/AddContact';
import UserProfile from 'pages/users/UserProfile';
import AIAssistant from 'pages/ai_assistant/AIAssistant';
import { SSEProvider } from 'providers/SSEProvider';
import UpdateContactTH from 'pages/contacts/UpdateContact';
import TrainingAndMentoring from 'pages/my_learning/Dashboard';
import MySkills from 'pages/skills/MySkills';
import AdminUsers from 'pages/users/AdminUsers';
import FindACoach from 'pages/my_learning/FindACoach';
import AdminUserProfileUpdate from 'pages/users/AdminUserProfileUpdate';
import MyFeedbackDashboard from 'pages/my_feedback/Dashboard';
import ReceivedFeedbacks from 'pages/my_feedback/ReceivedFeedbacks';
import AddFeedback from 'pages/my_feedback/AddFeedback';
import GivenFeedbacks from 'pages/my_feedback/GivenFeedbacks';
import UpdateFeedback from 'pages/my_feedback/UpdateFeedback';
import AddCertificate from 'pages/my_feedback/AddCertificate';
import Certificates from 'pages/my_feedback/Certificates';
import UpdateCertificate from 'pages/my_feedback/UpdateCertificate';
import FeedbackReports from 'pages/my_feedback/FeedbackReports';
import Resources from 'pages/my_learning/Resources';
import Courses from 'pages/courses/Courses';
import AdminCourses from 'pages/courses/AdminCourses';
import AddCourse from 'pages/courses/AddCourse';
import UpdateCourse from 'pages/courses/UpdateCourse';
import JobSkills from 'pages/skills/JobSkills';
import AdminSkillsTemplates from 'pages/skills/AdminSkillsTemplates';
import SignUpWizard from 'pages/authentication/SignUpWizard';
import SignUpFinalize from 'pages/authentication/SignUpFinalize';
import CommunityDashboard from 'pages/community/CommunityDashboard';
import AdminBlogs from 'pages/community/AdminBlogs';
import AddBlog from 'pages/community/AddBlog';
import UpdateBlog from 'pages/community/UpdateBlog';
import Prompts from 'pages/prompt_manager/PromptManager';
import IndividualConversations from 'pages/meetings/IndividualConversations';
import CoachingSessiondAnalysis from 'pages/analytics/CoachingSessionsAnalysis';
import MeetingsDashboard from 'pages/meetings/Dashboard';
import TeamConversations from 'pages/meetings/TeamConversations';
import AnalyticsDashboard from 'pages/analytics/AnalyticsDashboard';
import EngagementDashboard from 'pages/analytics/EngagementDashboard';
import CoachingStatsDashboard from 'pages/analytics/CoachingStats';
import Magazine from 'pages/community/Magazine';
import Events from 'pages/community/Events';
import CoachingReports from 'pages/analytics/CoachingReports';
import CoachingSessiondAnalysisDetails from 'pages/analytics/CoachingSessiondAnalysisDetails';
import BehaviouralInsightDashboard from 'pages/analytics/BehaviouralInsightDashboard';
import ForgotPassword from 'pages/authentication/ForgotPassword';
import AdminUserProfileAdd from 'pages/users/AdminUserProfileAdd';
import CustomerSelector from 'pages/customers/CustomerSelector';
import WorkLifeBalanceTracker from 'pages/analytics/WorkLifeBalanceTracker';
import QAForum from 'pages/forum/Forum';
import QAForumQuestionDetail from 'pages/forum/ForumQuestionDetail';
import SkillsTracker from 'pages/analytics/SkillsTracker ';
import FileManager from 'pages/file_manager/Files';
import HoganCompass from 'pages/skills/HoganCompass';
import HoganCareer from 'pages/skills/HoganCareer';
import MyResources from 'pages/my_resources/MyResources';
import TaskManagement from 'pages/analytics/TaskManagement';
import APIAssistantTester from 'pages/api_assistant_tester/APIAssistantTester';

function RequireAuth({ children }: { children: JSX.Element }) {
  const auth = useAuth();
  const location = useLocation();

  //console.log("RequireAuth:" + auth);
  if (!auth.user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}


const FontAwesomeExample = lazy(
  () => import('pages/template/modules/components/FontAwesomeExample')
);

const FeatherIconsExample = lazy(
  () => import('pages/template/modules/components/FeatherIconsExample')
);

const UniconsExample = lazy(
  () => import('pages/template/modules/components/UniconsExample')
);

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      /* Public pages */
      {
        path: '/',
        element: <SimpleSignIn />,
      },

      {
        path: "sign-in",
        element: <SimpleSignIn />,
      },

      {
        path: "signup",
        element: <SignUpWizard />,
      },
      {
        path: "activate",
        element: <SignUpFinalize />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />
      },


      {
        element: (
          <RequireAuth>
            <SSEProvider>
              <MainLayoutProvider>
                <MainLayout />
              </MainLayoutProvider>
            </SSEProvider>
          </RequireAuth>
        ),
        children: [
          {
            path: '/dashboard',
            children: [
              {
                index: true,
                path: 'home',
                element: <Home />
              },

            ]
          },

          {
            path: '/customer/selector',
            element: <CustomerSelector />
          },

          {
            path: '/feedback-dashboard',
            children: [
              {
                index: true,
                element: <MyFeedbackDashboard />
              },
              {
                path: 'received-feedbacks',
                element: <ReceivedFeedbacks />,
              },
              {
                path: 'given-feedbacks',
                element: <GivenFeedbacks />,
              },

              {
                path: 'received-feedbacks/add/:feedback_type',
                element: <AddFeedback />
              },
              {
                path: 'given-feedbacks/add/:feedback_type',
                element: <AddFeedback />
              },

              {
                path: 'received-feedbacks/edit/:feedback_id',
                element: <UpdateFeedback feedback_type='received' />
              },
              {
                path: 'given-feedbacks/edit/:feedback_id',
                element: <UpdateFeedback feedback_type='given' />
              },

              {
                path: 'certificates',
                element: <Certificates />,
              },
              {
                path: 'certificates/add',
                element: <AddCertificate />
              },
              {
                path: 'certificates/edit/:certificate_id',
                element: <UpdateCertificate />
              },

              {
                path: 'feedback-reports',
                element: <FeedbackReports />,
              },


            ]
          },

          {
            path: '/effective-communication',
            element: <MeetingsDashboard />
          },
          {
            path: '/effective-communication/individual',
            element: <IndividualConversations />
          },
          {
            path: '/effective-communication/team',
            element: <TeamConversations />
          },
          {
            path: '/effective-communication/:conversation_type/:resource_id',
            element: <ConversationDetails />
          },
          {
            path: '/analytics',
            element: <AnalyticsDashboard />,
          },
          {
            path: '/analytics/statistics/engagement',
            element: <EngagementDashboard />,
          },
          {
            path: '/analytics/statistics/task-management',
            element: <TaskManagement />
          },
          {
            path: '/analytics/coaching-stats',
            element: <CoachingStatsDashboard />,
          },
          {
            path: '/analytics/skills-tracker',
            element: <SkillsTracker />,
          },
          /*
          {
            path: '/analytics/coaching-sessions',
            element: <CoachingSessiondAnalysis />,
          },
          {
            path: '/analytics/coaching-sessions/:resource_id',
            element: <CoachingSessiondAnalysisDetails />,
          },
          */

          {
            path: '/analytics/coaching-reports',
            element: <CoachingReports />,
          },

          // potenzialmente da togliere
          {
            path: '/analytics/behavioural-insight',
            element: <BehaviouralInsightDashboard />,
          },


          {
            path: '/analytics/work-life-balance-tracker',
            element: <WorkLifeBalanceTracker />,
          },


          {
            path: '/contacts',
            element: <Contacts />,
          },
          {
            path: '/contacts/add-contact',
            element: <AddContactTH />
          },
          {
            path: '/contacts/update-contact',
            element: <UpdateContactTH />
          },
          {
            path: '/learning',
            element: <TrainingAndMentoring />
          },

          {
            path: '/myskills',
            element: <MySkills />
          },

          {
            path: '/myskills/job-skills',
            element: <JobSkills />
          },
          {
            path: '/myskills/hogan/compass',
            element: <HoganCompass />
          },
          {
            path: '/myskills/hogan/career',
            element: <HoganCareer />
          },
          {
            path: '/admin/skills-templates',
            element: <AdminSkillsTemplates />
          },
          {
            path: '/training/find_a_coach',
            element: <FindACoach />
          },
          {
            path: '/training/resources',
            element: <Resources />
          },
          {
            path: '/training/courses',
            element: <Courses />
          },
          {
            path: '/ai-assistant',
            element: <AIAssistant title={"AI Assistant"} />
          },
          {
            path: '/community',
            element: <CommunityDashboard />
          },
          {
            path: '/community/events',
            element: <Events />
          },
          {
            path: '/community/magazine',
            element: <Magazine />
          },
          {
            path: '/community/forum',
            element: <QAForum />
          },
          {
            path: '/community/forum/question/:question_id',
            element: <QAForumQuestionDetail />
          },
          {
            path: '/users/profile',
            element: <UserProfile />
          },
          {
            path: '/notifications',
            element: <Notifications />
          },
          {
            path: '/settings',
            element: <Settings />
          },
          {
            path: '/feed',
            element: <Feed />
          },
          {
            path: '/admin/users',
            element: <AdminUsers />
          },
          {
            path: '/admin/users/add',
            element: <AdminUserProfileAdd />
          },
          {
            path: '/admin/users/update/:id',
            element: <AdminUserProfileUpdate />
          },

          {
            path: '/admin/courses',
            element: <AdminCourses />
          },
          {
            path: '/admin/courses/add',
            element: <AddCourse />
          },
          {
            path: '/admin/courses/:course_id/update',
            element: <UpdateCourse />
          },

          {
            path: '/admin/blogs',
            element: <AdminBlogs />
          },
          {
            path: '/admin/blogs/add',
            element: <AddBlog />
          },
          {
            path: '/admin/blogs/:blog_id/update',
            element: <UpdateBlog />
          },

          {
            path: '/admin/prompts',
            element: <Prompts />
          },

          {
            path: '/resources',
            element: <MyResources />
          },

          {
            path: '/admin/files',
            element: <FileManager />
          },

          {
            path: '/admin/ai-assistant-tester',
            element: <APIAssistantTester />
          },


        ]
      },

      /** 
       * Demo pages
       */

      {
        path: '/apps',
        children: [
          {
            path: 'e-commerce/admin',
            children: [
              {
                path: 'add-product',
                element: <AddProduct />
              },
              {
                path: 'products',
                element: <Products />
              },
              {
                path: 'customers',
                element: <Customers />
              },
              {
                path: 'orders',
                element: <Orders />
              },
              {
                path: 'order-details',
                element: <OrderDetails />
              },
              {
                path: 'refund',
                element: <Refund />
              },
              {
                path: 'customer-details',
                element: <CustomerDetails />
              }
            ]
          },
          {
            path: 'crm',
            children: [
              {
                path: 'analytics',
                element: <Analytics />
              },
              {
                path: 'deals',
                element: <Deals />
              },
              {
                path: 'deal-details',
                element: <DealDetails />
              },
              {
                path: 'report-details',
                element: <ReportDetails />
              },
              {
                path: 'leads',
                element: <Leads />
              },
              {
                path: 'lead-details',
                element: <LeadDetails />
              },
              {
                path: 'reports',
                element: <Reports />
              },
              {
                path: 'add-contact',
                element: <AddContact />
              }
            ]
          },
          {
            path: 'project-management',
            children: [
              {
                path: 'create-new',
                element: <CreateNew />
              },
              {
                path: 'project-list-view',
                element: <ProjectListView />
              },
              {
                path: 'project-card-view',
                element: <ProjectCardView />
              },
              {
                path: 'project-board-view',
                element: <ProjectBoardView />
              },
              {
                path: 'todo-list',
                element: <ProjectTodoList />
              },
              {
                path: 'project-details',
                element: <ProjectDetails />
              }
            ]
          },
          {
            path: 'events',
            children: [
              {
                path: 'create-an-event',
                element: <CreateAnEvent />
              },
              {
                path: 'event-detail',
                element: <EventDetail />
              }
            ]
          },
          {
            path: 'kanban',
            children: [
              {
                path: 'kanban',
                element: <Kanban />
              },
              {
                path: 'boards',
                element: <Boards />
              },
              {
                path: 'create-board',
                element: <CreateBoard />
              }
            ]
          },
          {
            path: 'chat',
            element: <Chat />,
            children: [
              {
                index: true,
                element: <ChatHomepage />
              },
              {
                path: ':userId/conversation',
                element: <ChatConversation />
              }
            ]
          },
          {
            path: 'social',
            children: [
              {
                path: 'profile-demo',   // modificato
                element: <SocialProfile />
              },
              {
                path: 'settings-demo',
                element: <Settings />   // modficato
              },
              {
                path: 'feed-demo',
                element: <Feed />
              }
            ]
          },
          {
            path: 'calendar',
            element: <Calendar />
          },
          {
            path: 'email',
            children: [
              {
                path: 'inbox',
                element: <Inbox />
              },
              {
                path: 'email-detail',
                element: <EmailDetail />
              },
              {
                path: 'compose',
                element: <Compose />
              }
            ]
          }
        ]
      },
      {
        path: '/pages',
        children: [
          {
            path: 'faq',
            children: [
              {
                path: 'faq-accordion',
                element: <FaqAccordion />
              },
              {
                path: 'faq-tab',
                element: <FaqTab />
              }
            ]
          },
          {
            path: 'members',
            element: <Members />
          },
          {
            path: 'coming-soon',
            element: <ComingSoon />
          },
          {
            path: 'demo',
            children: [
              {
                path: 'vertical-sidenav',
                element: <VerticalSidenav />
              },
              {
                path: 'dark-mode',
                element: <DarkModeDemo />
              },
              {
                path: 'sidenav-collapse',
                element: <SidenavCollapse />
              },
              {
                path: 'darknav',
                element: <Darknav />
              },
              {
                path: 'topnav-slim',
                element: <TopnavSlim />
              },
              {
                path: 'navbar-top-slim',
                element: <NavbarTopSlim />
              },
              {
                path: 'navbar-top',
                element: <NavbarTop />
              },
              {
                path: 'horizontal-slim',
                element: <NavbarHorizontalSlim />
              },
              {
                path: 'combo-nav',
                element: <ComboNav />
              },
              {
                path: 'combo-nav-slim',
                element: <ComboNavSlim />
              },
              {
                path: 'dual-nav',
                element: <DualNav />
              }
            ]
          }
        ]
      },
      {
        path: '/modules',
        children: [
          {
            path: 'tables',
            children: [
              {
                path: 'basic-tables',
                element: <BasicTableExample />
              },
              {
                path: 'advance-tables',
                element: <AdvanceTableExample />
              }
            ]
          },
          {
            path: 'charts',
            children: [
              {
                path: 'e-charts',
                element: <ECharts />
              },
              {
                path: 'gantt-chart',
                element: <GanttChart />
              }
            ]
          },
          {
            path: 'icons',
            children: [
              {
                path: 'font-awesome',
                element: (
                  <Suspense fallback={<PhoenixLoader />}>
                    <FontAwesomeExample />
                  </Suspense>
                )
              },
              {
                path: 'feather',
                element: (
                  <Suspense fallback={<PhoenixLoader />}>
                    <FeatherIconsExample />
                  </Suspense>
                )
              },
              {
                path: 'unicons',
                element: (
                  <Suspense fallback={<PhoenixLoader />}>
                    <UniconsExample />
                  </Suspense>
                )
              }
            ]
          },
          {
            path: 'components',
            children: [
              {
                path: 'accordion',
                element: <AccordionExample />
              },
              {
                path: 'avatar',
                element: <AvatarExample />
              },
              {
                path: 'alerts',
                element: <AlertsExample />
              },
              {
                path: 'button',
                element: <ButtonExample />
              },
              {
                path: 'badge',
                element: <BadgeExample />
              },
              {
                path: 'breadcrumb',
                element: <BreadcrumbExample />
              },
              {
                path: 'card',
                element: <CardExample />
              },
              {
                path: 'carousel/bootstrap',
                element: <BootstrapCarousel />
              },
              {
                path: 'carousel/swiper',
                element: <SwiperCarousel />
              },
              {
                path: 'collapse',
                element: <CollapseExample />
              },
              {
                path: 'dropdown',
                element: <DropdownExample />
              },
              {
                path: 'list-group',
                element: <ListGroupExample />
              },
              {
                path: 'countup',
                element: <CountupExample />
              },
              {
                path: 'draggable',
                element: <DraggableExample />
              },
              {
                path: 'modal',
                element: <ModalExample />
              },
              {
                path: 'offcanvas',
                element: <OffcanvasExample />
              },
              {
                path: 'progress-bar',
                element: <ProgressbarExample />
              },
              {
                path: 'placeholder',
                element: <PlaceholderExample />
              },
              {
                path: 'pagination',
                element: <PaginationExample />
              },
              {
                path: 'popovers',
                element: <PopoversExample />
              },
              {
                path: 'spinners',
                element: <SpinnerExample />
              },
              {
                path: 'toast',
                element: <ToastsExample />
              },
              {
                path: 'tooltips',
                element: <TooltipExample />
              },
              {
                path: 'calendar',
                element: <CalendarExample />
              },
              {
                path: 'navs-and-tabs/navs',
                element: <NavsExample />
              },
              {
                path: 'navs-and-tabs/tabs',
                element: <TabsExample />
              },
              {
                path: 'navs-and-tabs/navbar',
                element: <NavbarExample />
              },
              {
                path: 'pictures/lightbox',
                element: <LightboxExample />
              }
            ]
          },
          {
            path: 'forms',
            children: [
              {
                path: 'form-control',
                element: <FormControlExample />
              },
              {
                path: 'input-group',
                element: <InputGroupExample />
              },
              {
                path: 'select',
                element: <SelectExample />
              },
              {
                path: 'checks',
                element: <ChecksExample />
              },
              {
                path: 'range',
                element: <RangeExample />
              },
              {
                path: 'floating-labels',
                element: <FloatingLabelExample />
              },
              {
                path: 'layout',
                element: <FormLayoutExample />
              },
              {
                path: 'editor',
                element: <EditorExample />
              },
              {
                path: 'advance-select',
                element: <AdvanceSelectExample />
              },
              {
                path: 'date-picker',
                element: <DatePickerExample />
              },
              {
                path: 'emoji-button',
                element: <EmojiButtonExample />
              },
              {
                path: 'file-uploader',
                element: <FileUploaderExample />
              },
              {
                path: 'rating',
                element: <RatingExample />
              },
              {
                path: 'validation',
                element: <FormValidationExample />
              },
              {
                path: 'wizard',
                element: <WizardExample />
              }
            ]
          },
          {
            path: 'utilities',
            children: [
              {
                path: 'background',
                element: <BackgroundExample />
              },
              {
                path: 'borders',
                element: <BorderExample />
              },
              {
                path: 'colors',
                element: <ColorsExample />
              },
              {
                path: 'display',
                element: <DisplayExample />
              },
              {
                path: 'grid',
                element: <GridExample />
              },
              {
                path: 'flex',
                element: <FlexExample />
              },
              {
                path: 'stack',
                element: <StackExample />
              },
              {
                path: 'float',
                element: <FloatExample />
              },
              {
                path: 'interactions',
                element: <InteractionsExample />
              },
              {
                path: 'opacity',
                element: <OpacityExample />
              },
              {
                path: 'overflow',
                element: <OverflowExample />
              },
              {
                path: 'position',
                element: <PositionExample />
              },
              {
                path: 'shadows',
                element: <ShadowsExample />
              },
              {
                path: 'sizing',
                element: <SizingExample />
              },
              {
                path: 'spacing',
                element: <SpacingExample />
              },
              {
                path: 'typography',
                element: <TypographyExample />
              },
              {
                path: 'vertical-align',
                element: <VerticalAlignExample />
              },
              {
                path: 'visibility',
                element: <VisibilityExample />
              }
            ]
          }
        ]
      },
      {
        path: '/documentation',
        children: [
          {
            path: 'getting-started',
            element: <GettingStarted />
          },
          {
            path: 'design-file',
            element: <DesignFile />
          },
          {
            path: 'customization',
            children: [
              {
                path: 'configuration',
                element: <Configuration />
              },
              {
                path: 'styling',
                element: <Styling />
              },
              {
                path: 'dark-mode',
                element: <DarkMode />
              }
            ]
          }
        ]
      },
      {
        path: 'changelog',
        element: <ChangeLog />
      },
      {
        path: 'migrations',
        element: <Migrations />
      },
      {
        path: 'widgets',
        element: <Widgets />
      },
      {
        element: <EcommerceLayout />,
        path: '/apps/e-commerce/customer/',
        children: [
          {
            path: 'homepage',
            element: <Homepage />
          },
          {
            path: 'product-details',
            element: <ProductDetails />
          },
          {
            path: 'cart',
            element: <Cart />
          },
          {
            path: 'checkout',
            element: <Checkout />
          },
          {
            path: 'shipping-info',
            element: <ShippingInfo />
          },
          {
            path: 'profile',
            element: <Profile />
          },
          {
            path: 'products-filter',
            element: <ProductsFilter />
          },
          {
            path: 'wishlist',
            element: <Wishlist />
          },
          {
            path: 'favorite-stores',
            element: <FavoriteStores />
          },
          {
            path: 'order-tracking',
            element: <OrderTracking />
          },
          {
            path: 'invoice',
            element: <Invoice />
          }
        ]
      },
      {
        path: 'pages/landing',
        children: [
          {
            path: 'default',
            element: <Default />
          },
          {
            path: 'alternate',
            element: <Alternate />
          }
        ]
      },
      {
        path: '/pages/errors/',
        children: [
          {
            path: '404',
            element: <Error404 />
          },
          {
            path: '403',
            element: <Error403 />
          },
          {
            path: '500',
            element: <Error500 />
          }
        ]
      },
      /*
      {
        path: '/pages/authentication/simple/',
        children: [
          {
            path: 'sign-in',
            element: <SimpleSignIn />
          },
          {
            path: 'sign-up',
            element: <SimpleSignUp />
          },
          {
            path: 'sign-out',
            element: <SimpleSignOut />
          },
          {
            path: 'forgot-password',
            element: <SimpleForgotPassword />
          },
          {
            path: 'reset-password',
            element: <SimpleResetPassword />
          },
          {
            path: 'lock-screen',
            element: <SimpleLockScreen />
          },
          {
            path: '2FA',
            element: <SimpleTwoFA />
          }
        ]
      },
      */
      {
        path: '/pages/authentication/split/',
        children: [
          {
            path: 'sign-in',
            element: <SplitSignIn />
          },
          {
            path: 'sign-up',
            element: <SplitSignUp />
          },
          {
            path: 'sign-out',
            element: <SplitSignOut />
          },
          {
            path: 'forgot-password',
            element: <SplitForgotPassword />
          },
          {
            path: 'reset-password',
            element: <SplitResetPassword />
          },
          {
            path: 'lock-screen',
            element: <SplitLockScreen />
          },
          {
            path: '2FA',
            element: <SplitTwoFA />
          }
        ]
      },
      {
        path: '/pages/authentication/card/',
        children: [
          {
            path: 'sign-in',
            element: <CardSignIn />
          },
          {
            path: 'sign-up',
            element: <CardSignUp />
          },
          {
            path: 'sign-out',
            element: <CardSignOut />
          },
          {
            path: 'forgot-password',
            element: <CardForgotPassword />
          },
          {
            path: 'reset-password',
            element: <CardResetPassword />
          },
          {
            path: 'lock-screen',
            element: <CardLockScreen />
          },
          {
            path: '2FA',
            element: <CardTwoFA />
          }
        ]
      },
      {
        path: 'showcase',
        element: <Showcase />
      },

      /** Fall back rule to catch all not configured pages */
      {
        path: '*',
        element: <Navigate to="/dashboard" replace />
      }



    ]
  }];

/*
const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: (
          <MainLayoutProvider>
            <MainLayout />
          </MainLayoutProvider>
        ),
        children: [
          {
            index: true,
            element: <Ecommerce />
          },
          {
            path: '/dashboard',
            children: [
              {
                path: 'project-management',
                element: <ProjectManagement />
              },
              {
                path: 'crm',
                element: <Crm />
              }
            ]
          },
          {
            path: '/apps',
            children: [
              {
                path: 'e-commerce/admin',
                children: [
                  {
                    path: 'add-product',
                    element: <AddProduct />
                  },
                  {
                    path: 'products',
                    element: <Products />
                  },
                  {
                    path: 'customers',
                    element: <Customers />
                  },
                  {
                    path: 'orders',
                    element: <Orders />
                  },
                  {
                    path: 'order-details',
                    element: <OrderDetails />
                  },
                  {
                    path: 'refund',
                    element: <Refund />
                  },
                  {
                    path: 'customer-details',
                    element: <CustomerDetails />
                  }
                ]
              },
              {
                path: 'crm',
                children: [
                  {
                    path: 'analytics',
                    element: <Analytics />
                  },
                  {
                    path: 'deals',
                    element: <Deals />
                  },
                  {
                    path: 'deal-details',
                    element: <DealDetails />
                  },
                  {
                    path: 'report-details',
                    element: <ReportDetails />
                  },
                  {
                    path: 'leads',
                    element: <Leads />
                  },
                  {
                    path: 'lead-details',
                    element: <LeadDetails />
                  },
                  {
                    path: 'reports',
                    element: <Reports />
                  },
                  {
                    path: 'add-contact',
                    element: <AddContact />
                  }
                ]
              },
              {
                path: 'project-management',
                children: [
                  {
                    path: 'create-new',
                    element: <CreateNew />
                  },
                  {
                    path: 'project-list-view',
                    element: <ProjectListView />
                  },
                  {
                    path: 'project-card-view',
                    element: <ProjectCardView />
                  },
                  {
                    path: 'project-board-view',
                    element: <ProjectBoardView />
                  },
                  {
                    path: 'todo-list',
                    element: <ProjectTodoList />
                  },
                  {
                    path: 'project-details',
                    element: <ProjectDetails />
                  }
                ]
              },
              {
                path: 'events',
                children: [
                  {
                    path: 'create-an-event',
                    element: <CreateAnEvent />
                  },
                  {
                    path: 'event-detail',
                    element: <EventDetail />
                  }
                ]
              },
              {
                path: 'kanban',
                children: [
                  {
                    path: 'kanban',
                    element: <Kanban />
                  },
                  {
                    path: 'boards',
                    element: <Boards />
                  },
                  {
                    path: 'create-board',
                    element: <CreateBoard />
                  }
                ]
              },
              {
                path: 'chat',
                element: <Chat />,
                children: [
                  {
                    index: true,
                    element: <ChatHomepage />
                  },
                  {
                    path: ':userId/conversation',
                    element: <ChatConversation />
                  }
                ]
              },
              {
                path: 'social',
                children: [
                  {
                    path: 'profile',
                    element: <SocialProfile />
                  },
                  {
                    path: 'settings',
                    element: <Settings />
                  },
                  {
                    path: 'feed',
                    element: <Feed />
                  }
                ]
              },
              {
                path: 'calendar',
                element: <Calendar />
              },
              {
                path: 'email',
                children: [
                  {
                    path: 'inbox',
                    element: <Inbox />
                  },
                  {
                    path: 'email-detail',
                    element: <EmailDetail />
                  },
                  {
                    path: 'compose',
                    element: <Compose />
                  }
                ]
              }
            ]
          },
          {
            path: '/pages',
            children: [
              {
                path: 'starter',
                element: <Starter />
              },
              {
                path: 'faq',
                children: [
                  {
                    path: 'faq-accordion',
                    element: <FaqAccordion />
                  },
                  {
                    path: 'faq-tab',
                    element: <FaqTab />
                  }
                ]
              },
              {
                path: 'pricing',
                children: [
                  {
                    path: 'pricing-column',
                    element: <PricingColumn />
                  },
                  {
                    path: 'pricing-grid',
                    element: <PricingGrid />
                  }
                ]
              },
              {
                path: 'notifications',
                element: <Notification />
              },
              {
                path: 'members',
                element: <Members />
              },
              {
                path: 'timeline',
                element: <Timeline />
              },
              {
                path: 'coming-soon',
                element: <ComingSoon />
              },
              {
                path: 'demo',
                children: [
                  {
                    path: 'vertical-sidenav',
                    element: <VerticalSidenav />
                  },
                  {
                    path: 'dark-mode',
                    element: <DarkModeDemo />
                  },
                  {
                    path: 'sidenav-collapse',
                    element: <SidenavCollapse />
                  },
                  {
                    path: 'darknav',
                    element: <Darknav />
                  },
                  {
                    path: 'topnav-slim',
                    element: <TopnavSlim />
                  },
                  {
                    path: 'navbar-top-slim',
                    element: <NavbarTopSlim />
                  },
                  {
                    path: 'navbar-top',
                    element: <NavbarTop />
                  },
                  {
                    path: 'horizontal-slim',
                    element: <NavbarHorizontalSlim />
                  },
                  {
                    path: 'combo-nav',
                    element: <ComboNav />
                  },
                  {
                    path: 'combo-nav-slim',
                    element: <ComboNavSlim />
                  },
                  {
                    path: 'dual-nav',
                    element: <DualNav />
                  }
                ]
              }
            ]
          },
          {
            path: '/modules',
            children: [
              {
                path: 'tables',
                children: [
                  {
                    path: 'basic-tables',
                    element: <BasicTableExample />
                  },
                  {
                    path: 'advance-tables',
                    element: <AdvanceTableExample />
                  }
                ]
              },
              {
                path: 'charts',
                children: [
                  {
                    path: 'e-charts',
                    element: <ECharts />
                  },
                  {
                    path: 'gantt-chart',
                    element: <GanttChart />
                  }
                ]
              },
              {
                path: 'icons',
                children: [
                  {
                    path: 'font-awesome',
                    element: (
                      <Suspense fallback={<PhoenixLoader />}>
                        <FontAwesomeExample />
                      </Suspense>
                    )
                  },
                  {
                    path: 'feather',
                    element: (
                      <Suspense fallback={<PhoenixLoader />}>
                        <FeatherIconsExample />
                      </Suspense>
                    )
                  },
                  {
                    path: 'unicons',
                    element: (
                      <Suspense fallback={<PhoenixLoader />}>
                        <UniconsExample />
                      </Suspense>
                    )
                  }
                ]
              },
              {
                path: 'components',
                children: [
                  {
                    path: 'accordion',
                    element: <AccordionExample />
                  },
                  {
                    path: 'avatar',
                    element: <AvatarExample />
                  },
                  {
                    path: 'alerts',
                    element: <AlertsExample />
                  },
                  {
                    path: 'button',
                    element: <ButtonExample />
                  },
                  {
                    path: 'badge',
                    element: <BadgeExample />
                  },
                  {
                    path: 'breadcrumb',
                    element: <BreadcrumbExample />
                  },
                  {
                    path: 'card',
                    element: <CardExample />
                  },
                  {
                    path: 'carousel/bootstrap',
                    element: <BootstrapCarousel />
                  },
                  {
                    path: 'carousel/swiper',
                    element: <SwiperCarousel />
                  },
                  {
                    path: 'collapse',
                    element: <CollapseExample />
                  },
                  {
                    path: 'dropdown',
                    element: <DropdownExample />
                  },
                  {
                    path: 'list-group',
                    element: <ListGroupExample />
                  },
                  {
                    path: 'countup',
                    element: <CountupExample />
                  },
                  {
                    path: 'draggable',
                    element: <DraggableExample />
                  },
                  {
                    path: 'modal',
                    element: <ModalExample />
                  },
                  {
                    path: 'offcanvas',
                    element: <OffcanvasExample />
                  },
                  {
                    path: 'progress-bar',
                    element: <ProgressbarExample />
                  },
                  {
                    path: 'placeholder',
                    element: <PlaceholderExample />
                  },
                  {
                    path: 'pagination',
                    element: <PaginationExample />
                  },
                  {
                    path: 'popovers',
                    element: <PopoversExample />
                  },
                  {
                    path: 'spinners',
                    element: <SpinnerExample />
                  },
                  {
                    path: 'toast',
                    element: <ToastsExample />
                  },
                  {
                    path: 'tooltips',
                    element: <TooltipExample />
                  },
                  {
                    path: 'calendar',
                    element: <CalendarExample />
                  },
                  {
                    path: 'navs-and-tabs/navs',
                    element: <NavsExample />
                  },
                  {
                    path: 'navs-and-tabs/tabs',
                    element: <TabsExample />
                  },
                  {
                    path: 'navs-and-tabs/navbar',
                    element: <NavbarExample />
                  },
                  {
                    path: 'pictures/lightbox',
                    element: <LightboxExample />
                  }
                ]
              },
              {
                path: 'forms',
                children: [
                  {
                    path: 'form-control',
                    element: <FormControlExample />
                  },
                  {
                    path: 'input-group',
                    element: <InputGroupExample />
                  },
                  {
                    path: 'select',
                    element: <SelectExample />
                  },
                  {
                    path: 'checks',
                    element: <ChecksExample />
                  },
                  {
                    path: 'range',
                    element: <RangeExample />
                  },
                  {
                    path: 'floating-labels',
                    element: <FloatingLabelExample />
                  },
                  {
                    path: 'layout',
                    element: <FormLayoutExample />
                  },
                  {
                    path: 'editor',
                    element: <EditorExample />
                  },
                  {
                    path: 'advance-select',
                    element: <AdvanceSelectExample />
                  },
                  {
                    path: 'date-picker',
                    element: <DatePickerExample />
                  },
                  {
                    path: 'emoji-button',
                    element: <EmojiButtonExample />
                  },
                  {
                    path: 'file-uploader',
                    element: <FileUploaderExample />
                  },
                  {
                    path: 'rating',
                    element: <RatingExample />
                  },
                  {
                    path: 'validation',
                    element: <FormValidationExample />
                  },
                  {
                    path: 'wizard',
                    element: <WizardExample />
                  }
                ]
              },
              {
                path: 'utilities',
                children: [
                  {
                    path: 'background',
                    element: <BackgroundExample />
                  },
                  {
                    path: 'borders',
                    element: <BorderExample />
                  },
                  {
                    path: 'colors',
                    element: <ColorsExample />
                  },
                  {
                    path: 'display',
                    element: <DisplayExample />
                  },
                  {
                    path: 'grid',
                    element: <GridExample />
                  },
                  {
                    path: 'flex',
                    element: <FlexExample />
                  },
                  {
                    path: 'stack',
                    element: <StackExample />
                  },
                  {
                    path: 'float',
                    element: <FloatExample />
                  },
                  {
                    path: 'interactions',
                    element: <InteractionsExample />
                  },
                  {
                    path: 'opacity',
                    element: <OpacityExample />
                  },
                  {
                    path: 'overflow',
                    element: <OverflowExample />
                  },
                  {
                    path: 'position',
                    element: <PositionExample />
                  },
                  {
                    path: 'shadows',
                    element: <ShadowsExample />
                  },
                  {
                    path: 'sizing',
                    element: <SizingExample />
                  },
                  {
                    path: 'spacing',
                    element: <SpacingExample />
                  },
                  {
                    path: 'typography',
                    element: <TypographyExample />
                  },
                  {
                    path: 'vertical-align',
                    element: <VerticalAlignExample />
                  },
                  {
                    path: 'visibility',
                    element: <VisibilityExample />
                  }
                ]
              }
            ]
          },
          {
            path: '/documentation',
            children: [
              {
                path: 'getting-started',
                element: <GettingStarted />
              },
              {
                path: 'design-file',
                element: <DesignFile />
              },
              {
                path: 'customization',
                children: [
                  {
                    path: 'configuration',
                    element: <Configuration />
                  },
                  {
                    path: 'styling',
                    element: <Styling />
                  },
                  {
                    path: 'dark-mode',
                    element: <DarkMode />
                  }
                ]
              }
            ]
          },
          {
            path: 'changelog',
            element: <ChangeLog />
          },
          {
            path: 'migrations',
            element: <Migrations />
          },
          {
            path: 'widgets',
            element: <Widgets />
          }
        ]
      },

      {
        element: <EcommerceLayout />,
        path: '/apps/e-commerce/customer/',
        children: [
          {
            path: 'homepage',
            element: <Homepage />
          },
          {
            path: 'product-details',
            element: <ProductDetails />
          },
          {
            path: 'cart',
            element: <Cart />
          },
          {
            path: 'checkout',
            element: <Checkout />
          },
          {
            path: 'shipping-info',
            element: <ShippingInfo />
          },
          {
            path: 'profile',
            element: <Profile />
          },
          {
            path: 'products-filter',
            element: <ProductsFilter />
          },
          {
            path: 'wishlist',
            element: <Wishlist />
          },
          {
            path: 'favorite-stores',
            element: <FavoriteStores />
          },
          {
            path: 'order-tracking',
            element: <OrderTracking />
          },
          {
            path: 'invoice',
            element: <Invoice />
          }
        ]
      },
      {
        path: 'pages/landing',
        children: [
          {
            path: 'default',
            element: <Default />
          },
          {
            path: 'alternate',
            element: <Alternate />
          }
        ]
      },
      {
        path: '/pages/errors/',
        children: [
          {
            path: '404',
            element: <Error404 />
          },
          {
            path: '403',
            element: <Error403 />
          },
          {
            path: '500',
            element: <Error500 />
          }
        ]
      },
      {
        path: '/pages/authentication/simple/',
        children: [
          {
            path: 'sign-in',
            element: <SimpleSignIn />
          },
          {
            path: 'sign-up',
            element: <SimpleSignUp />
          },
          {
            path: 'sign-out',
            element: <SimpleSignOut />
          },
          {
            path: 'forgot-password',
            element: <SimpleForgotPassword />
          },
          {
            path: 'reset-password',
            element: <SimpleResetPassword />
          },
          {
            path: 'lock-screen',
            element: <SimpleLockScreen />
          },
          {
            path: '2FA',
            element: <SimpleTwoFA />
          }
        ]
      },
      {
        path: '/pages/authentication/split/',
        children: [
          {
            path: 'sign-in',
            element: <SplitSignIn />
          },
          {
            path: 'sign-up',
            element: <SplitSignUp />
          },
          {
            path: 'sign-out',
            element: <SplitSignOut />
          },
          {
            path: 'forgot-password',
            element: <SplitForgotPassword />
          },
          {
            path: 'reset-password',
            element: <SplitResetPassword />
          },
          {
            path: 'lock-screen',
            element: <SplitLockScreen />
          },
          {
            path: '2FA',
            element: <SplitTwoFA />
          }
        ]
      },
      {
        path: '/pages/authentication/card/',
        children: [
          {
            path: 'sign-in',
            element: <CardSignIn />
          },
          {
            path: 'sign-up',
            element: <CardSignUp />
          },
          {
            path: 'sign-out',
            element: <CardSignOut />
          },
          {
            path: 'forgot-password',
            element: <CardForgotPassword />
          },
          {
            path: 'reset-password',
            element: <CardResetPassword />
          },
          {
            path: 'lock-screen',
            element: <CardLockScreen />
          },
          {
            path: '2FA',
            element: <CardTwoFA />
          }
        ]
      },
      {
        path: 'showcase',
        element: <Showcase />
      },
      {
        path: '*',
        element: <Error404 />
      }
    ]
  }
];
*/
export const router = createBrowserRouter(routes);

export default routes;
